import axiosInstance from "../interceptor/interceptor";
import dictionary from "../dictionary";

const { support } = dictionary;

export interface CreateTicketPayload {
  loanAccountNumber: string;
  description: string;
}

export interface CallbackRequestPayload {
  ticketNumber: string;
  reason: string;
  context: string;
}
export interface CallbackSMRequestPayload {
  trackingId: string;
}

const supportService = {
  createTicket: (formData: FormData) =>
    axiosInstance.post(support.createTicket(), formData),

  getTickets: (params?: { page?: number; limit?: number; status?: string; search?: string }) =>
    axiosInstance.get(support.getTickets(), { params }),

  getTicketListing: (body: { data: string }, page?: number, limit?: number, refresh?: boolean) => {
    const params = new URLSearchParams();
    if (page !== undefined && page !== null) params.append("page", page.toString());
    if (limit !== undefined && limit !== null) params.append("limit", limit.toString());
    // Only sent when explicitly requested via the Refresh button.
    if (refresh) params.append("refresh", "true");
    const query = params.toString();
    return axiosInstance.post(
      query ? `${support.getTicketListing()}?${query}` : support.getTicketListing(),
      body
    );
  },

  // `page` pages the ticket's conversation: page 1 is the first batch, and the "View more"
  // button on Ticket Details asks for the next one.
  getTicketDetails: (ticketNumber: string | number, reqId: string | number, page: number = 1) =>
    axiosInstance.get(`${support.getTicketDetails(ticketNumber)}?page=${page}&reqId=${reqId}`),

  urgentRequests: (formData: FormData) =>
    axiosInstance.post(support.urgentRequests(), formData),

  updateTicket: (payload: {
    description: string;
    reason: string;
    ticketId: string;
    requesterId: string;
  }) => axiosInstance.post(support.updateTicket(), payload),

  requestCallback: (payload: CallbackRequestPayload) =>
    axiosInstance.post(support.requestCallback(), payload),

  requestSalesManagerCallback: (payload: CallbackSMRequestPayload) =>
    axiosInstance.post(support.requestSMCallback(), payload),

  verifyTicket: (ticketId: string) =>
    axiosInstance.get(support.verifyTicket(ticketId)),

  sendOtp: (payload: { phone?: string; email?: string; name?: string }) =>
    axiosInstance.post(support.sendOtp(), payload),

  verifyOtp: (payload: { inputCode: string; identifier: string }) =>
    axiosInstance.post(support.verifyOtp(), payload),

  stateCheckpoint: (id: string | number, payload: { identifier: string }) =>
    axiosInstance.post(support.stateCheckpoint(id), payload),

  // authToken (qrc/otp/verify's "data") is sent as "Bearer <authToken>" — see
  // authOverride in the request interceptor.
  userVerification: (payload: { identifier: string }, authToken?: string) =>
    axiosInstance.post(
      support.userVerification(),
      payload,
      authToken ? ({ authOverride: authToken } as any) : undefined
    ),

  extendTicketTime: (ticketId: string) =>
    axiosInstance.post(support.extendTicketTime(ticketId), {}),

  submitComplaintOnTicket: (formData: FormData) =>
    axiosInstance.post(support.submitComplaintOnTicket(), formData),

  submitComplaintNoTicket: (formData: FormData) =>
    axiosInstance.post(support.submitComplaintNoTicket(), formData),
};

export default supportService;
